// UI ve loading yönetimi için merkezi yardımcı katman
// Element Plus ve Vue ile uyumlu

import { ElMessage } from 'element-plus';
import { useVideoStore } from '@/stores/videoStore';

// Kullanıcıya hata mesajı gösterir
export function notifyError(message: string) {
  ElMessage({
    message,
    type: 'error',
    duration: 5000
  });
}

// Kullanıcıya uyarı mesajı gösterir
export function notifyWarning(message: string) {
  ElMessage({
    message,
    type: 'warning',
    duration: 5000
  });
}

// Spinner'ları zorla kapatır (videoId opsiyonel)
export function forceCloseSpinners(videoId?: string) {
  const videoStore = useVideoStore();
  videoStore.setLoadingState('transcript', false);
  videoStore.setLoadingState('summary', false);
  videoStore.setLoadingState('processing', false);
  // Eğer videoId ile daha özel bir işlem yapmak istersen buraya ekleyebilirsin
}

// Zamanlayıcıları yönetmek için yardımcılar
const summaryTimeouts: Record<string, Record<string, ReturnType<typeof setTimeout>>> = {};

// Belirli bir video ve timeout tipi için zamanlayıcı kurar
export function setSummaryTimeout(videoId: string, timeoutType: string, callback: () => void, delay: number) {
  if (!summaryTimeouts[videoId]) summaryTimeouts[videoId] = {};
  // Önceki timeout'u temizle
  if (summaryTimeouts[videoId][timeoutType]) {
    clearTimeout(summaryTimeouts[videoId][timeoutType]);
  }
  summaryTimeouts[videoId][timeoutType] = setTimeout(callback, delay);
}

// Bir videoId'ye ait tüm zamanlayıcıları temizler
export function clearSummaryTimeouts(videoId: string) {
  if (summaryTimeouts[videoId]) {
    Object.values(summaryTimeouts[videoId]).forEach(clearTimeout);
    delete summaryTimeouts[videoId];
  }
} 